
import objectPath from 'object-path'
import moment from 'moment'
import initialStateTransfer from './initialState'
import { cart } from '@/utils/mapping'

const mutations = {
  clearTransfersState(state) {
    state.transfers = []
  },
  setTransferInitial(state) {
    state.transfers.push(initialStateTransfer())
  },
  setTransfers(state, { transferIndex, results, searchId }) {
    const collection = results.map(item => cart.transfer(item))

    state.transfers[transferIndex].serviceLoaded = true

    const current = {
      name: 'Не выбрано',
      slug: null,
      transferId: null,
      vehicleId: null,

      price: {
        amount: 0,
        markup: 0,
        currency: collection[0].price.currency,
      },
    }

    collection.unshift(current)

    state.transfers[transferIndex].transfers = {
      ...state.transfers[transferIndex].transfers,
      isLoading: false,
      current,
      searchId,
      collection
    }
  },
  setTransferStartDate(state, { transferIndex, date }) {
    objectPath.set(state, `transfers.${transferIndex}.form.checkInDate`, moment.unix(date).format('DD.MM.YYYY'))
  },
  setTransferPlaces(state, payload) {
    const {
      transferIndex,
      cityFrom,
      placeFrom,
      cityTo,
      placeTo
    } = payload

    objectPath.set(state, `transfers.${transferIndex}.form.cityFrom`, cityFrom)
    objectPath.set(state, `transfers.${transferIndex}.form.placeFrom.collection`, [{
      label: '',
      collection: [{
        badge: null,
        code: placeFrom.code,
        name: placeFrom.name,
        slug: `${placeFrom.slug}_${placeFrom.code}`
      }]
    }])
    objectPath.set(state, `transfers.${transferIndex}.form.placeFrom.current`, `${placeFrom.slug}_${placeFrom.code}`)
    objectPath.set(state, `transfers.${transferIndex}.form.cityTo`, cityTo)
    objectPath.set(state, `transfers.${transferIndex}.form.placeTo.collection`, [{
      label: '',
      collection: [{
        badge: null,
        code: placeTo.code,
        name: placeTo.name,
        slug: `${placeTo.slug}_${placeTo.code}`
      }]
    }])
    objectPath.set(state, `transfers.${transferIndex}.form.placeTo.current`, `${placeTo.slug}_${placeTo.code}`)
  },
  updateTransfersCurrent(state, { target, value }) {
    const getterTarget = target.replace('.current', '')
    const result = objectPath.get(state, getterTarget).collection.find(item => item.slug === value)

    objectPath.set(state, target, result)
  },
  setCitiesLocations(state, { collection, direction, transferIndex }) {
    state.transfers[transferIndex].form[direction].collection = collection.map(
      item => cart.citiesLocations(item)
    )
  },
  setTransfersPenalties(state, { target, penalties }) {
    objectPath.set(state, `${target}.penalties`, {
      ...objectPath.get(state, `${target}.penalties`),
      isLoading: false,
      collection: penalties
    })
  },
}

export default mutations